module.exports = __webpack_public_path__ + "img/forum-blog-forum.37e5ca57.svg";